<template>
<div class="md-layout">
    <div class="md-layout-item md-size-50 md-small-size-100">
      <pricing-card card-bg="info">
        <template slot="cardContent"> <h5 class="card-category">Proximamente</h5>
          <h1 class="card-title">
            CLUB HOUSE 
          </h1>
          <ul>
            <li>
              <b>Contará con:</b></li>
            <li>
              Bar, Chimenea, X box</li>
            <li>
              Futbolito, Billar  </li>
                <li>
              Centro de Entrenimiento </li>
          </ul>
        </template>
      </pricing-card>
    </div>   

    <div class="md-layout-item md-size-50 md-small-size-100">
        <!-- <br>
        <img class="img-raised rounded" alt="Raised Image"
        :src="aboutOffice.aboutOffice6" > -->
        <el-carousel
            indicator-position="none"
            trigger="click"
            :interval="5000"
            class="imagen wrapper"
          >
            <el-carousel-item
              v-for="item in carousel"
              :key="item.image"
              class="imagen wrapper"
            >
              <img
                :src="item.image"
                alt="Raised Image"
                :style="styleObject.carruselgaleria"
              />
            </el-carousel-item>
          </el-carousel>
    </div> 
  </div>
</template>
<script>

import Mixins from "@/plugins/basicMixins";
import {PricingCard} from '@/components'
import { Carousel } from "element-ui";
import Vue from "vue";

export default {
  components: {
  PricingCard,

    
  },
  mixins: [Mixins.HeaderImage],
  data() {
    Vue.use(Carousel);
    return {
      cardProject: {
        cardProject3: require("@/assets/img/examples/card-project6.jpg")
      },
      cardFullBg: {
        fullBg1: require("@/assets/img/examples/mariya-georgieva.jpg")
      },
      aboutOffice: {
        
        aboutOffice6: require("@/assets/img/examples/club.jpg")
        
      },
      carousel: [
        {
          image: require("@/assets/img/carrusel/1.jpeg"),
          title: "",
        },
        {
          image: require("@/assets/img/carrusel/2.jpeg"),
          title: "",
        },
        {
          image: require("@/assets/img/carrusel/3.jpeg"),
          title: "",
        },
        {
          image: require("@/assets/img/carrusel/4.jpeg"),
          title: "",
        },
        {
          image: require("@/assets/img/carrusel/5.jpeg"),
          title: "",
        },
        {
          image: require("@/assets/img/carrusel/6.jpeg"),
          title: "",
        }
      ],
      styleObject: {
        carruselgaleria: {
          height: "100%",
          width: "100%",
        },
      },
    };
  }
};
</script>

<style lang="scss">
.imagen {
  height: 500px !important;
  width: 1060px !important;
}
</style>